import React, { useState, Fragment } from 'react';
import { Box, Button, Checkbox, Modal, Snackbar, Alert } from '@mui/material';
import CreditCardsList from './CreditCardsList'; 
import CreditCardsModal from '../../../../components/editCreditCardsModal';
import DebounceInput from '../../../../components/DebounceInput';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

export default function CreditCardsListWithTools({assignedUserId}) {
  const [showInactiveCards, setShowInactiveCards] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [creditCardOnEditing, setCreditCardOnEditing] = useState(null);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackBarProp, setSnackBarProp] = useState({
    status: null,
    text: '',
    snackBarOpenProp: false,
  });

  const handleSnackBarClose = () => setSnackBarOpen(false);

  return (
    <Fragment>
  <div style={{ width: '100%', height: 425, display: 'flex', flexDirection: 'column' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom: '0.75em' }}>
     
      <div style={{ display: 'flex', width: '50%' }}>
        <div style={{ width: '50%' }}>
          <DebounceInput
            sx={{ width: '100%' }}
            defaultValue={searchText}
            placeholder="Search..."
            debounceTimeout={500}
            handleDebounce={(value) => setSearchText(value)}
          />
        </div>

        {/* Show inactive cards checkbox */}
        <div>
          <Checkbox
            checked={showInactiveCards}
            id="showInactiveCards"
            name="Show Inactive Cards"
            onClick={() => setShowInactiveCards(prev => !prev)}
          />
          <label htmlFor="showInactiveCards" style={{ fontSize: '14px', color: 'var(--orange)' }}>
            Show Inactive Cards
          </label>
        </div>
      </div>

    </div>

    {/* Credit cards list */}
    <div style={{ flex: 1, overflow: 'auto' }}>
      <CreditCardsList
        isDeleted={false}
        active={!showInactiveCards}
        assignedUserId={assignedUserId}
        search={searchText}
        onEditCard={setCreditCardOnEditing} 
      />
    </div>
  </div>

 
  {/* Modal to edit credit card */} 
  {creditCardOnEditing && (
    <Modal open={true} onClose={() => setCreditCardOnEditing(null)}>
      <Box sx={style}>
        <CreditCardsModal
          creditCard={creditCardOnEditing}
          setEditing={setCreditCardOnEditing}
          onSubmit={() => {
            setSnackBarProp({ status: 'success', text: 'Credit card updated successfully!' });
            setSnackBarOpen(true);
          }}
        />
      </Box>
    </Modal>
  )}

  {/* Snackbar to show success message */}
  <Snackbar open={snackBarOpen} autoHideDuration={6000} onClose={handleSnackBarClose}>
    <Alert onClose={handleSnackBarClose} severity="success" sx={{ width: '100%' }}>
      {snackBarProp.text}
    </Alert>
  </Snackbar>
</Fragment>
  );
}
